import AssessmentChallengeDetails from '@pages/assessmentChallenges/AssessmentChallengeDetails';
import AssessmentChallenges from '@pages/assessmentChallenges/AssessmentChallenges';
import Submissions from '@pages/assessmentChallenges/submissions/Submissions';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Submission from '@pages/assessmentChallenges/submissions/Submission';
import CreateAssessment from '@pages/assessmentChallenges/submissions/assessment/create/CreateAssessment';
import EditAssessment from '@pages/assessmentChallenges/submissions/assessment/edit/EditAssessment';
import EditOrganisation from '@pages/assessmentChallenges/submissions/EditOrganisation';

const AssessmentsRoutes: React.FC = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={path}>
                <AssessmentChallenges />
            </Route>
            <Route exact path={`${path}/challenge/:id`}>
                <AssessmentChallengeDetails />
            </Route>

            <Route exact path={`${path}/submissions/submission/:id`}>
                <Submission />
            </Route>

            <Route exact path={`${path}/submissions/assessment/assess/:id`}>
                <CreateAssessment />
            </Route>

            <Route exact path={`${path}/submissions/assessment/edit/:id`}>
                <EditAssessment />
            </Route>

            <Route exact path={`${path}/edit-application/:id`}>
                <EditOrganisation />
            </Route>

            <Route exact path={`${path}/submissions/:id`}>
                <Submissions />
            </Route>
        </Switch>
    );
};

export default AssessmentsRoutes;
